import { Backdrop, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC, Fragment } from 'react';
import Particles from "react-particles";
import { Engine } from 'tsparticles-engine';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
}));

interface SuspenseFallbackProps {
    options: any;
    init: (engine: Engine) => Promise<void>;
    loaded: (container: any | undefined) => Promise<void>
}

export const SuspenseFallback: FC<SuspenseFallbackProps> = (props) => {
    const classes = useStyles();
    return (
        <Fragment>
            <Backdrop
                className={classes.backdrop}
                open={true}
            >
                <Particles id="tsparticles" {...props} />
                <CircularProgress size="6rem" color="inherit" />
            </Backdrop>
        </Fragment>
    );
}